import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider as ReduxProvider } from "react-redux";
import store from "./redux/store";
import { DOMRoot } from "./components/Modal";
import { agGridLicense } from "./gridUtils/agGridLicense";
import { ModuleRegistry } from "ag-grid-community";
import {
  AllEnterpriseModule,
  LicenseManager,
  SparklinesModule,
} from "ag-grid-enterprise";

import "./index.css";
import "./styles/global.scss";
import "./styles/tab.scss";
import "./styles/header.scss";
import "./styles/tooltip.scss";
import "./styles/queryAttributes.scss";
import "./styles/queryMeasures.scss";
import "./styles/modal.scss";
import "./styles/dashboard.scss";
import "./styles/ag-grid-override.scss";
import "./styles/slider.scss";
import "./styles/queryResults.scss";
import "./styles/breadcrumb.scss";
import "./styles/home.scss";
import "./styles/subscription.scss";
import "./styles/accordian.scss";
import "./styles/radio.scss";
import axios from "axios";
import { AccessDenied } from "./pages/AccessDenied";
import { AgChartsCommunityModule } from "ag-charts-community";
import { ServerIssue } from "./pages/ServerIssue";
import LoadingOverlay from "./components/LoadingOverlay";
LicenseManager.setLicenseKey(agGridLicense);
ModuleRegistry.registerModules([
  AllEnterpriseModule,
  SparklinesModule.with(AgChartsCommunityModule),
]);
const apiUrl = import.meta.env.VITE_API_URL;

const axiosInstance = axios.create({
  baseURL: "",
});

const fetchApiUrl = async () => {
  try {
    const response = await axiosInstance.get("/api/url");
    return response.data.url;
  } catch (error) {
    console.error("Error fetching api url:", error);
    return null;
  }
};

const fetchUiVersion = async () => {
  try {
    const response = await axiosInstance.get("/api/version");
    console.log("API Version fetched:", response.data.version);
    return response.data.version;
  } catch (error) {
    console.error("Error fetching api version:", error);
    return null;
  }
};

const fetchInitialData = async (api: string, setErrorCode: any) => {
  try {
    let axiosInstance = null;

    if (api) {
      localStorage.setItem("apiUrl", api);
      axiosInstance = axios.create({
        baseURL: api,
        withCredentials: true,
        headers: {
          SameSite: "None",
        },
      });
    } else {
      localStorage.setItem("apiUrl", apiUrl);
      axiosInstance = axios.create({
        baseURL: apiUrl,
        withCredentials: true,
        headers: {
          SameSite: "None",
        },
      });
    }
    const response = await axiosInstance.get("/rest/user/authenticate"); // Replace with your API endpoint
    return response.data;
  } catch (error) {
    console.error("Error fetching initial data:", error);
    return "API_ERROR"; // Return 'Error' if the request fails
  }
};
const AuthWrapper = () => {
  const [loading, setLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorCode, setErrorCode] = useState("");
  useEffect(() => {
    fetchUiVersion().then((version) => {
      if (version) {
        localStorage.setItem("uiVersion", version);
        console.log("UI Version:", version);
      }
    });
    const loadData = async () => {
      const apiUrl = await fetchApiUrl();
      setLoading(true);
      if (window.location.href.indexOf("auth/logoutPage") === -1) {
        const data = await fetchInitialData(apiUrl, setErrorCode);
        if (data === "Success") {
          setLoading(false);
        } else if (data === "Error" || data.indexOf("auth/logoutPage") !== -1) {
          setLoading(false);
          setErrorCode("ACCESS_DENIED");
          setIsError(true);
        } else if (
          data === "API_ERROR" ||
          data.indexOf("auth/logoutPage") !== -1
        ) {
          setLoading(false);
          setErrorCode("SERVER_ISSUE");
          setIsError(true);
        } else {
          // Session is not valid, redirect to login page from URL in data response
          if (window.location.hostname !== "localhost") {
            window.location.href = data;
          } else {
            setLoading(false);
          }
        }
      } else {
        setErrorCode("ACCESS_DENIED");
        setLoading(false);
        setIsError(true); // Set error state if the URL contains 'auth/logoutPage'
      }
    };

    loadData();
  }, []);

  if (loading) {
    return (
      <div>
        <LoadingOverlay isGlobalLoading={true} show={true} />
      </div>
    ); // You can replace this with a loading spinner or any other loading indicator
  }
  if (isError) {
    return errorCode == "ACCESS_DENIED" ? (
      <AccessDenied />
    ) : (
      errorCode == "SERVER_ISSUE" && <ServerIssue />
    ); // You can replace this with a loading spinner or any other loading indicator
  }

  return (
    <ReduxProvider store={store}>
      <DOMRoot>
        <App />
      </DOMRoot>
    </ReduxProvider>
  );
};
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <AuthWrapper />,
);
